import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EarlyAccessSubscribeModalComponent } from '../common/subscribe-modal/subscribe-modal.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  @ViewChild('subscribeModal') subscribeModal!: ElementRef;
  modal_text: string = '';

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit(): void { }

  openSubscribeModal(modal_text: string) {
    this.modal_text = modal_text;
    this.modalService.open(this.subscribeModal, {
      centered: true,
      size: "md",
      modalDialogClass: 'modal-cls1'
    });
  }
}
